// extracted by mini-css-extract-plugin
module.exports = {"select_kpi":"KpisSettingsPopup_select_kpi__1nALg","text_field":"KpisSettingsPopup_text_field__2hJ63"};